import { FETCH_TOPUP, RESET_TOPUP } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const topUpViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TOPUP:
      return { data: action.payload };
    case RESET_TOPUP:
      return initialState;
    default:
      return state;
  }
};

export default topUpViewReducer;
